<template>
  <app-header></app-header>
  <div class="productInfo-wrapper">
    <SwiperComponent
      v-show="historyImg.length > 0"
      :slideItem="historyImg"
      :loop="true"
      :centeredSlides="true"
      :navigation="{
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      }"
      :pagination="false"
      :breakpoints="{
        576: { slidesPerView: 1.75, spaceBetween: 50 },
        0: { slidesPerView: 1.2, spaceBetween: 10 },
      }"
      :isMobile="isMobile"
    />
  </div>
  <section class="catalog-detail history-review">
    <div class="info-left">
      <h1 class="title">{{ historyProductDetail.name }}</h1>
      <div class="time">
        <p>
          <i class="bi bi-calendar-week"></i>
          <span>{{ historyProductDetail.time }}</span>
        </p>
      </div>
      <ul class="options">
        <li v-for="(content, index) in historyInfo" :key="index" @click="scrollToContent(index)">
          {{ content.title }}
        </li>
      </ul>
      <div v-for="(intoContent, index) in historyInfo" :key="index" class="into-list" ref="contentRefs">
        <h2 class="into-title">{{ intoContent.title }}</h2>
        <div v-show="intoContent.content" class="into-content" v-html="intoContent.content"></div>
        <div v-show="intoContent.image" class="into-content" v-html="intoContent.image" @click="planImageClick"></div>
      </div>
    </div>
  </section>
  <app-footer></app-footer>
</template>
<script>
import AppHeader from '@/components/Header.vue';
import AppFooter from '@/components/Footer.vue';
import SwiperComponent from '@/components/CarouselContainer.vue';
import { historyProductDetail } from '@/api/infoSerivce.js';
export default {
  name: 'history-review-detail',
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
    SwiperComponent,
  },
  mounted() {
    this.fetchHistoryProductDetail();
  },
  data() {
    return {
      historyImg: [],
      historyInfo: [],
      historyProductDetail: {},
    };
  },
  props: {},
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {
    async fetchHistoryProductDetail() {
      try {
        this.loading = true;
        const langSetting = this.currentLanguage === 'zh_tw' ? 'zh-tw' : this.currentLanguage;
        const eventRouter = this.$route.query.eventRoute;
        const response = await historyProductDetail(langSetting, eventRouter);
        this.historyProductDetail = response.data.data;
        this.historyProductDetail.time = this.formatTimeRange(this.historyProductDetail.startTime, this.historyProductDetail.endTime);
        this.historyImg = this.historyProductDetail.carouselItems;
        this.historyInfo = this.historyProductDetail.details;
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        this.loading = false;
      }
    },
    formatTimeRange(startTime, endTime) {
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);

      const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');

        this.timeZone = date.toString().match(/\(([^)]+)\)$/)[1];
        return `${yyyy}/${mm}/${dd}`;
      };

      const formattedStart = formatDate(startDate);
      const formattedEnd = formatDate(endDate);

      return `${formattedStart} ~ ${formattedEnd}`;
    },
    scrollToContent(index) {
      const contentRef = this.$refs.contentRefs[index];
      if (contentRef) {
        let offsetTop;
        if (this.isMobile) {
          offsetTop = contentRef.offsetTop - 90;
        } else {
          offsetTop = contentRef.offsetTop - 45;
        }
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/components/catalog-detail.scss';
.history-review {
  min-height: 70vh;
}
</style>
